export default __webpack_public_path__ + "static/media/miguel-lopes-38.6334b590.jpg";